module.exports = __webpack_public_path__ + "img/EditionSelection.c6f993ed.jpg";